import React, {useRef} from 'react';
import {FormGroup, Label} from 'reactstrap';

import {useFieldState, fieldStateCtx, ErrorTooltip} from '@/Form/index';

const RadioGroup = ({id, name, label, children, ...rest}) => {
  const fieldState = useFieldState({id, name});
  const {errors} = fieldState;
  const refContainer = useRef(null);

  return (
    <FormGroup check {...rest}>
      {label && <Label>{label}</Label>}
      <fieldStateCtx.Provider value={fieldState}>
        <div ref={refContainer} className='block-inline-checks'>
          {children}
        </div>
      </fieldStateCtx.Provider>
      <ErrorTooltip errors={errors} target={refContainer.current} />
    </FormGroup>
  );
};

export default RadioGroup;
